module.exports = __webpack_public_path__ + "media/images/logo_evergreen-66fcffa0fcc32c96ac7900be648ec64a.svg";